import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiRequestInterceptorService implements HttpInterceptor {

  readonly baseUrl: string = environment.adminApiUrl;

  constructor(private injector: Injector) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // if (this.baseUrl && request.url && request.url.startsWith(this.baseUrl)) {
      const headers = {
        'Cache-Control': '',
        'Pragma': '',
        'Expires': '',
        'Authorization': '',
      };
      if (request.method.toUpperCase() === 'GET') {
        headers['Cache-Control'] = 'no-cache';
        headers['Pragma'] = 'no-cache';
        headers['Expires'] = 'Sat, 01 Jan 2000 00:00:00 GMT';
      }
      const authnService = this.injector.get(AuthService);
      const token: string = authnService.getToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      request = request.clone({ setHeaders: headers });
    // }

    return next.handle(request);
  }
}
